export enum ShipmentType {
    Air = 1,
    Ocean, 
    CourierExpress,
    Inland
}